export enum PageTitle {
  viewFlights = "View Flights",
  editFlightSeries = "Edit Series Flights",
  addFlightSeries = "Add Series Flights",
  downloadFlights = "Download Flights",
  reportFlights = "Report Flights",
  downloadCancelled = "Download Canx Flights",
  downloadCancelledHandling = "Download Canx Flights",
  oscar = "OSCAR",
  week = "Week",
  weekOutOfHours = "Week Out of Hours",
  seasonDayOperation = "Season by Day of Operation",
  seasonTime = "Season by Time",
  weekHour = "Week by Hour",
  seasonHour = "Season by Hour",
  baselinePeakWeek = "Baseline Peak Week",
  detailWeek = "Detail Week",
  detailWeekOOH = "Detail Week Out of Hours",
  detailSeason = "Detail Season",
  viewGaBaFlights = "View GA/BA Flights",
  addGaBaFlights = "Add GA/BA Flights",
  editGaBaFlights = "Edit GA/BA Flights",
  editSingleDateFlights = "Edit Single Date Flights",
  addSingleDateFlights = "Add Single Date Flights",
  editShlFlights = "Edit SHL Flights",
  EditOffers = "Edit Offered Flights",
  viewBaselineFlights = "View Baseline Flights",
  viewEuacaFlights = "View EUACA Flights",
  addSubmissionFlights = "Add Submission Flights",
  slotMonitoring = "Slot Monitoring",
  responseFlow = "Response Flow",
  addHandling = "Add PPR",
  viewHandling = "View PPR",
  editParking = "Edit PPR",
  availabilityHandling = "Parking availability",
  disableMessageProcessing = "Disable Message Processing"
}

export enum PageContent {
  searchCriteria = "Search Criteria",
  startDate = "Start Date",
  endDate = "End Date",
  disclaimer = "Disclaimer",
  cookies = "Cookie policy",
  contactUs = "Contact Us",
  format = "Format",
  warning = "Warning",
  information = "Information",
  export = "Export",
  download = "Download"
}
export enum LoginContent {
  username = "Username",
  password = "Password",
  disclaimerText = "By entering this website you confirm your acceptance of the",
  logUserOutBtn = "Log out other user",
  anotherUser = "Another user is logged in.",
  failedLogin = "Too many failed login attempts.",
  unlockCodeSent = "An unlock code was sent to the account’s email address.",
  unlockCodeNotSent = "An unlock code could not be sent to the account's email address. Please try again later or",
  unlockBtn = "Unlock",
  watchTheVideo = "Watch the video",
  prompVideoText = "Explore how easy it is to identify and apply for available slots with OCS"
}

export enum warningSelectTime {
  title = "Select Time",
  content = "If you change Time type, you will lose your current data"
}
export enum warningSelectSeason {
  title = "Select Season",
  content = "If you change Season, you will lose your current data"
}
